import { create } from 'zustand'

/** The feed's query key, shared by the Wall, its menu and the map's tab dot. */
export const WALL_KEY = ['wall'] as const

/**
 * When you last had the Wall open (FR-WAL-12): the tab's dot means someone else has posted since.
 * Kept on the device; a fresh device starts from now, so it never opens with a stale dot.
 */
const KEY = 'fml.wallSeen'
function load(): number {
  try {
    const v = Number(localStorage.getItem(KEY))
    if (v > 0) return v
  } catch {}
  return Date.now()
}
export const useWallSeen = create<{ at: number; mark: () => void }>((set) => ({
  at: load(),
  mark() {
    const at = Date.now()
    try {
      localStorage.setItem(KEY, String(at))
    } catch {}
    set({ at })
  },
}))
